import { DefaultDateFormat, IConfigAction, Modal } from "./types/configTypes";

export const configOnEditing = (action: Modal): IConfigAction<any> => {
  return {
    type: "CONFIG_EDITING",
    payload: action,
  };
};

export const configPathname = (pathname: string): IConfigAction<any> => {
  return {
    type: "CONFIG_PATHNAME",
    payload: pathname,
  };
};

export const configDefaultDateFormat = (
  dateFormat: DefaultDateFormat
): IConfigAction<any> => {
  return {
    type: "CONFIG_DEFAULT_DATE_FORMAT",
    payload: dateFormat,
  };
};

export const configReset = (): IConfigAction<any> => {
  return {
    type: "CONFIG_RESET_MODAL",
  };
};

export const configFocusResetOn = (): IConfigAction<any> => {
  return {
    type: "CONFIG_FOCUSRESET_ON",
  };
};

export const configFocusResetOff = (): IConfigAction<any> => {
  return {
    type: "CONFIG_FOCUSRESET_OFF",
  };
};

export const configSetIsScanning = (value: boolean): IConfigAction<any> => {
  return {
    type: "CONFIG_SET_IS_SCANNING",
    payload: value,
  };
};

export const configBackupInputValue = (value: string): IConfigAction<any> => {
  return {
    type: "CONFIG_BACKUP_INPUT_VALUE",
    payload: value,
  };
};
